module.exports = __webpack_public_path__ + "static/media/guangtoushan_plant.ee8ceed1.png";